import { gql } from '@apollo/client';

export type HrsOnBeat = {
  head: number;
  tail: number;
};

const HrsOnBeatFragment = gql`
  fragment HrsOnBeatFragment on HrsOnBeat {
    head
    tail
  }
`;

export default HrsOnBeatFragment;
